import UMCContentSplitLayout from "../common/UMCContentSplitLayout";
import { getTranslated, validateAttrStatus } from "../../utils/CommonUtils";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import reducer, { setContentLoading } from "../../store/reducers/CommonReducer";
import { getSessionItem } from "../../utils/storageUtils";
import { CC_PRODUCT_ID } from "../../utils/Constants";
import { UUM_URL } from "../../utils/Config";
import { getExistingGroupResponse, getGroupResponse, getUnAssociatedUsers } from "../../store/actions/CommonActions";
import { setHuntingGroupDetail, setExistingHuntingGroupDetail, setUnAssociatedUsersOfHuntingGroup } from "../../store/reducers/UUMReducer";
import { deepMergeObjects } from "../../utils/SchemaParseUtils";
import { setCurrentMergedData, setBaseMergeData } from "../../store/reducers/CommonReducer";
import UMCAttrComponentView from "../common/UMCAttrComponentView";
import UMCUsersList from "../common/UMCUsersList";
import confirmModal from "../common/confirmModal";
import { createHuntingGroup, updateHuntingGroup } from "../../store/actions/UUMActions";
import { validateAllMandatoryAttr } from "../../utils/ValidationUtils"
import { showOxeErrorsByCodesInDialog } from "../../store/actions/OxeActions";
import { sendGTMEvent } from "../../utils/GTMUtils";

const HuntingGroupDetailView = (props) => {

    const [domain_1View, setDomain_1View] = useState()
    const [domain_2View, setDomain_2View] = useState()

    const [addedUsers, setAddedUsers] = useState([]);

    const huntingGroupDetail = useSelector(state => state.uum.huntingGroupDetail) //create
    const existingHuntingGroupDetail = useSelector(state => state.uum.existingHuntingGroupDetail) //update
    const unAssociatedUsersOfHuntingGroup = useSelector(state => state.uum.unAssociatedUsersOfHuntingGroup) //store unassociated users during update

    const oxeErrorCodesFromStore = useSelector(state => state.common.oxeErrorCodes)

    const [isGroupDetailReady, setGroupDetailReady] = useState(false);

    const dict = useSelector(state => state.common.dict)
    const oxeCcProductId = useSelector(state => state.oxe.oxeCcProductId)
    const [usersMode, setUsersMode] = useState(); // "default", "review", or "delete"
    const [isUserListReady, setUserListReady] = useState(false);

    const currentMergedData = useSelector((state) => state.common.currentMergedData)
    const baseMergeData = useSelector((state) => state.common.baseMergeData)
    const oxeErrorCodes = useSelector((state) => state.common.oxeErrorCodes)

    const dispatch = useDispatch();

    useEffect(() => { //new
        dispatch(setContentLoading(true))
        return (() => {
            dispatch(setCurrentMergedData(null))
            dispatch(setHuntingGroupDetail(null))
            dispatch(setUnAssociatedUsersOfHuntingGroup(null))
            dispatch(setExistingHuntingGroupDetail(null))
            setDomain_1View(null)
            setDomain_2View(null)
        })
    }, [])

    useEffect(() => { //new
        if (props.currentOperation === 'create') {
            if (huntingGroupDetail?.length > 0) {
                if (domain_2View !== null && domain_1View !== null) {
                    dispatch(setContentLoading(false))
                }
            }
        }
        if (props.currentOperation === 'update') {
            if (existingHuntingGroupDetail?.length > 0 && Array.isArray(unAssociatedUsersOfHuntingGroup)) {
                if (domain_2View !== null && domain_1View !== null) {
                    dispatch(setContentLoading(false))
                }
            }
        }
    }, [huntingGroupDetail, existingHuntingGroupDetail, unAssociatedUsersOfHuntingGroup])

    //to get update GET
    useEffect(() => {
        if (props.currentOperation === "update") {
            if (props.groupToEdit) {
                const request = {
                    url: `${UUM_URL}/data/huntinggroup/${encodeURIComponent(props.groupToEdit)}`,
                    action: (data) => {
                        dispatch(setExistingHuntingGroupDetail(data));
                        setGroupDetailReady(true)
                    }
                };
                dispatch(getGroupResponse(props.currentOperation, request), () => {
                    props.setListViewMode(true)
                })

                if (getSessionItem(CC_PRODUCT_ID)) {
                    const request1 = { url: `${UUM_URL}/data/detail/list/huntinggroup/${getSessionItem(CC_PRODUCT_ID)}`, action: setUnAssociatedUsersOfHuntingGroup }
                    dispatch(getExistingGroupResponse(request1))
                }
            }
        }
    }, [props.groupToEdit, props.currentOperation])

    useEffect(() => { //change url to hunting group
        if (props.currentOperation === 'create') {
            if (getSessionItem(CC_PRODUCT_ID)) {
                const request = { url: `${UUM_URL}/data/detail/list/huntinggroup/${getSessionItem(CC_PRODUCT_ID)}`, action: setHuntingGroupDetail }
                dispatch(getGroupResponse(props.currentOperation, request), () => {
                    props.setListViewMode(true)
                })
            }
        }
    }, [props.currentOperation, oxeCcProductId, unAssociatedUsersOfHuntingGroup, props.groupToEdit])


    useEffect(() => {
        if (huntingGroupDetail?.length && props.currentOperation === "create") {
            const domains = huntingGroupDetail[0]?.domain
            const huntingGroup = domains.find(domain => domain.id === 'huntinggroup');

            if (huntingGroup?.subdomain?.length) {

                const createLeft = huntingGroup.subdomain.find(subDomain => subDomain.id === 'createleft');
                const createRight = huntingGroup.subdomain.find(subDomain => subDomain.id === 'createright');

                if (createLeft?.attribute) {
                    const domain1Content = getDomain1Content(createLeft)
                    setDomain_1View(domain1Content);

                    if (createLeft?.attribute) {
                        const schemaAttributes = getSchemaAttributes(createLeft)
                        let dataAttributes;
                        dataAttributes = getDataAttributes(createLeft)
                        const merged = getDeepMergedObjects(schemaAttributes, dataAttributes)
                        const flattenedAttributes = merged?.[0]?.subdomain?.[0]?.attribute || [];

                        dispatch(setBaseMergeData(flattenedAttributes));
                        dispatch(setCurrentMergedData(flattenedAttributes));
                    }
                }
                if (createRight) {
                    const domain2Content = getDomain2Content(createRight)
                    setDomain_2View(domain2Content)
                }
            }
        }
        if (existingHuntingGroupDetail?.length && props.currentOperation === 'update') {
            const eGD = existingHuntingGroupDetail[0]?.domain
            const huntingGroup = eGD.find(domain => domain.id === 'huntinggroup');

            if (huntingGroup?.subdomain?.length) {

                const createLeft = huntingGroup.subdomain.find(subDomain => subDomain.id === 'createleft');
                const createRight = huntingGroup.subdomain.find(subDomain => subDomain.id === 'createright');

                if (createLeft) {
                    if (createLeft?.attribute) {
                        //schema attr
                        const schemaAttributes = getSchemaAttributes(createLeft) //[{ subdomain: [{ attribute: createLeft.attribute }] }];
                        //data attributes
                        let dataAttributes;
                        dataAttributes = getDataAttributes(createLeft)

                        //merging
                        const merged = getDeepMergedObjects(schemaAttributes, dataAttributes)
                        const flattenedAttributes = merged?.[0]?.subdomain?.[0]?.attribute || [];

                        dispatch(setBaseMergeData(flattenedAttributes));
                        dispatch(setCurrentMergedData(flattenedAttributes));

                        const domain1Content = getDomain1Content(createLeft)
                        setDomain_1View(domain1Content);
                    }
                }
                if (createRight) {
                    const domain2Content = getDomain2Content(createRight)
                    setDomain_2View(domain2Content);
                }
            }
        }
    }, [huntingGroupDetail, existingHuntingGroupDetail, unAssociatedUsersOfHuntingGroup])
    //functions

    useEffect(() => {
        if (
            props.currentOperation === "update" &&
            isGroupDetailReady &&
            existingHuntingGroupDetail?.length
        ) {
            const eGD = existingHuntingGroupDetail[0]?.domain;
            const huntingGroup = eGD?.find((domain) => domain.id === "huntinggroup");
            const createRight = huntingGroup?.subdomain?.find(
                (subDomain) => subDomain.id === "createright"
            );

            const existingEnum = createRight?.list?.[0]?.enum || [];

            //Only set addedUsers if it's not yet initialized
            if (!addedUsers || addedUsers.length === 0) {
                setAddedUsers(existingEnum);
            }
        }
    }, [isGroupDetailReady, existingHuntingGroupDetail, props.currentOperation]);

    //check change in users for button enablement
    const checkChangeInUsersList = () => {
        if (existingHuntingGroupDetail) {

            const eGD = existingHuntingGroupDetail[0]?.domain
            if (eGD) {
                const huntingGroup = eGD.find(domain => domain.id === 'huntinggroup');
                const createRight = huntingGroup.subdomain.find(subDomain => subDomain.id === 'createright');

                if (createRight) {
                    const existingEnum = createRight?.list?.[0]?.enum || [];

                    //if (addedUsers.length === 0) return false; // removed as no user needed for hunting group
                    // Check if lengths differ
                    if (addedUsers.length !== existingEnum.length) {
                        return true;
                    }

                    // Convert both lists to maps for efficient comparison
                    const existingMap = new Map(existingEnum.map(user => [user.id, user.action]));
                    const addedMap = new Map(addedUsers.map(user => [user.id, user.action]));

                    for (let [id, action] of addedMap.entries()) {
                        if (!existingMap.has(id) || existingMap.get(id) !== action) {
                            return true; // user missing or action differs
                        }
                    }
                    return false; // No change
                }
            }
        }
    }

    const getSchemaAttributes = (createLeft) => {
        return [{ subdomain: [{ attribute: createLeft.attribute }] }]
    }

    const getDataAttributes = (createLeft) => {
        return [{
            subdomain: [{
                attribute: createLeft.attribute.map(attr => ({
                    id: attr.id,
                    value: attr.value ?? "",
                    oldValue: attr.value ?? ""
                }))
            }]
        }];
    }

    const getDeepMergedObjects = (schemaAttributes, dataAttributes) => {
        return deepMergeObjects(schemaAttributes, dataAttributes);
    }

    const getDomain1Content = (domain) => {
        const attributes = domain.attribute;

        const otherAttributes = {
            actionMode: props.currentOperation === 'create' ? "CREATE" : "UPDATE"
        }
        return attributes.map((attribute, index) => <UMCAttrComponentView attribute={{ ...attribute, ...otherAttributes }} />);
    }

    const getDomain2Content = (domain) => {
        const list = domain?.list[0]?.enum || [];
        return ( //default mode
            <UMCUsersList
                listItems={list} // all users - create | existing users - update
                width="100%"
                className="user-group-dd listbox-cmnt"
                placeholder={getTranslated(dict, "PH_SEARCH_GROUPS")}
                showAddButton={true}
                onAdd={(selected) => setAddedUsers(selected)}
                handleListBoxSelect={setAddedUsers}
                setModeInParent={setUsersMode} // default review delete
                isCreateMode={props.currentOperation === "create" ? true : false} //true -create | false - update
                unGroupedUsers={unAssociatedUsersOfHuntingGroup}
                onListLoaded={() => setUserListReady(true)}
            />
        )
        //}
    };

    const checkCreateButtonEnabled = () => {
        if (props.currentOperation === 'create') {
            const attributeMandatoryStatus = checkValidateAttributeForMandatoryFields(currentMergedData)
            return attributeMandatoryStatus;
        } else {
            const changeInFields = verifyChangeInFields()
            const userStatus = checkChangeInUsersList()
            return changeInFields || userStatus
        }
    }

    const checkValidateAttributeForAllFields = (currentMergeData) => {
        for (const attr of currentMergeData || []) {
            const status = validateAttrStatus(attr)
            if (!status) return status
        }
        return true;
    }

    const checkValidateAttributeForMandatoryFields = (currentMergedData) => {
        for (const attr of currentMergedData || []) {
            if (attr?.mandatory) {
                const status = validateAttrStatus(attr)
                if (!status) return status
            }
        } return true;
    }

    //compare currentMergeData and baseMergeData
    const verifyChangeInFields = () => {
        for (const base of baseMergeData || []) {
            const current = currentMergedData?.find(item => item.id === base.id);
            if (!current) continue; // if id not found, skip

            const baseVal = base.value || "";     // treat undefined/null as ""
            const currVal = current.value || "";
            if (baseVal !== currVal) {
                return true; // value changed
            }
        }
        return false;
    }

    const goBackHandler = () => {
        const changeInFields = verifyChangeInFields()
        const usersChange = addedUsers.length > 0 ? true : false

        const finalStatus = props.currentOperation === 'create'
            ? (changeInFields || usersChange)
            : (changeInFields || checkChangeInUsersList());
        if (finalStatus) {
            confirmModal({
                title: "MSG_LEAVE_PAGE",
                content: "MSG_LOSE_CONFIG",
                onOk: () => {
                    props.changeCreateMode(true)
                    setAddedUsers(null)
                    dispatch(setUnAssociatedUsersOfHuntingGroup(null))
                    dispatch(setExistingHuntingGroupDetail(null))
                    //dispatch(setPickupGroupDetail(null))
                    setGroupDetailReady(false)
                }
            })
        } else {
            props.changeCreateMode(true)
            setAddedUsers(null)
        }
    }

    const buildFinalPayload = () => {
        if (props.currentOperation === 'create') {
            if (!huntingGroupDetail?.[0]) return null;

            // Step 1: Clone the parent domain without `subdomain`
            const { domain, ...restOfResponse } = huntingGroupDetail[0];  // destructure to remove domain
            const clonedResponse = { ...restOfResponse }; // this will now have: uid,help,displayname,label

            const { subdomain: originalSubdomain, ...restOfDomain } = domain[0]; //destructure to remove subdomain from domain obj
            const clonedSubdomain = JSON.parse(JSON.stringify(originalSubdomain));
            const clonedDomain = { ...restOfDomain }; // has domain object without subdomain

            // Step 2: Deep clone subdomain array
            const leftSubdomain = clonedSubdomain.find(sd => sd.id === "createleft");
            if (leftSubdomain && Array.isArray(leftSubdomain.attribute)) {
                leftSubdomain.attribute.forEach(attr => {
                    const currentAttr = currentMergedData.find(i => i.id === attr.id);
                    const baseAttr = baseMergeData.find(i => i.id === attr.id);

                    if (currentAttr) {
                        attr.value = currentAttr.value;
                        attr.oldValue = baseAttr?.value ?? currentAttr.value;//old group name in case of update/or name same in old and new value
                    }
                });
            }

            // Update right-side user list
            const rightSubdomain = clonedSubdomain.find(sd => sd.id === "createright");
            if (rightSubdomain?.list) {
                const userList = rightSubdomain.list.find(list => list.id === "users");

                if (userList) {
                    userList.enum = addedUsers.map(user => {
                        return {
                            ...user,
                            action: "ADD"
                        };
                    });
                }
            }
            // Step 5: Assemble final domain object with updated subDomain
            clonedDomain.subdomain = clonedSubdomain;
            clonedResponse.domain = [clonedDomain];
            return clonedResponse;

        } else {
            if (!existingHuntingGroupDetail?.[0]) return null;

            // Step 1: Clone the parent domain without `subdomain`
            const { domain, ...restOfResponse } = existingHuntingGroupDetail[0];  // destructure to remove domain
            const clonedResponse = { ...restOfResponse }; // this will now have: uid,help,displayname,label

            const { subdomain: originalSubdomain, ...restOfDomain } = domain[0]; //destructure to remove subdomain from domain obj
            const clonedSubdomain = JSON.parse(JSON.stringify(originalSubdomain));
            const clonedDomain = { ...restOfDomain }; // has domain object without subdomain

            // Step 2: Deep clone subdomain array

            const leftSubdomain = clonedSubdomain.find(sd => sd.id === "createleft");

            if (leftSubdomain && Array.isArray(leftSubdomain.attribute)) {
                leftSubdomain.attribute.forEach(attr => {
                    const currentAttr = currentMergedData.find(i => i.id === attr.id);
                    const baseAttr = baseMergeData.find(i => i.id === attr.id);

                    if (currentAttr) {
                        attr.value = currentAttr.value;
                        attr.oldValue = baseAttr?.value ?? currentAttr.value;//old group name in case of update/or name same in old and new value
                    }
                });
            }

            // Update right-side user list
            const rightSubdomain = clonedSubdomain.find(sd => sd.id === "createright");
            if (rightSubdomain?.list) {
                const userList = rightSubdomain.list.find(list => list.id === "users");

                if (userList) {
                    const existingUsers = userList.enum || [];
                    //const finalUsers = addedUsers || [];
                    const finalUsers = Array.isArray(addedUsers) ? addedUsers : [];

                    // Create maps for fast lookup
                    const existingMap = new Map(existingUsers.map(user => [user.id, user]));
                    const finalMap = new Map(finalUsers.map(user => [user.id, user]));

                    const mergedUsers = [];

                    // First: check existing users
                    for (const user of existingUsers) {
                        if (finalMap.has(user.id)) {
                            mergedUsers.push({ ...user, action: "NO_ACTION" });
                        } else {
                            mergedUsers.push({ ...user, action: "DELETE" });
                        }
                    }

                    // Next: check for new users not in existing
                    for (const user of finalUsers) {
                        if (!existingMap.has(user.id)) {
                            mergedUsers.push({ ...user, action: "ADD" });
                        }
                    }
                    userList.enum = mergedUsers;
                }
            }
            // Step 5: Assemble final domain object with updated subDomain
            clonedDomain.subdomain = clonedSubdomain;
            clonedResponse.domain = [clonedDomain];
            return clonedResponse;
        }
    };

    const HandleOK = () => {
        if (props.currentOperation === 'create') {
            const status = checkValidateAttributeForAllFields(currentMergedData)
            if (checkCreateButtonEnabled() && status) {   //validation stage 
                const payload = buildFinalPayload();
                if (payload) {
                    dispatch(setContentLoading(true))
                    dispatch(createHuntingGroup(payload, (status, result) => {
                        validateResponse(status, result)
                    }))
                }
            }
        } else {
            const status = checkValidateAttributeForAllFields(currentMergedData)
            if (checkCreateButtonEnabled() && status) {
                const updatePayload = buildFinalPayload();
                if (updatePayload) {
                    dispatch(setContentLoading(true))
                    dispatch(updateHuntingGroup(props.groupToEdit, updatePayload, (status, result) => {
                        validateResponse(status, result)
                    }))
                }
            }
        }

        // send GTM event for hunting group creation/update
        sendGTMEvent({
            event: "umc_easy_user_groups",
            action: props.currentOperation === "create" ? "Hunting group creation triggered" : "Hunting group update triggered"
        })

        const validateResponse = (status, data) => {
            if (status) {
                dispatch(setBaseMergeData(null))
                dispatch(setCurrentMergedData(null))
                setAddedUsers(null)
                dispatch(setUnAssociatedUsersOfHuntingGroup(null))
                dispatch(setExistingHuntingGroupDetail(null))
                setGroupDetailReady(false)
                //dispatch(setPickupGroupDetail(null))
                props.setListViewMode(true)
                dispatch(setContentLoading(false))
            } else {
                dispatch(setContentLoading(false))
                dispatch(showOxeErrorsByCodesInDialog(data))
            }
        }
    }

    return <UMCContentSplitLayout
        domain_1={domain_1View}
        domain_2={domain_2View}
        heading_1={props.heading_1}
        heading_2={props.heading_2}
        okBtnLabel={props.currentOperation === 'create' ? getTranslated(dict, "LABEL_CREATE") : getTranslated(dict, "LABEL_UPDATE")}
        goBackHandler={() => goBackHandler()}
        handleOK={HandleOK}
        disablOKBtn={!checkCreateButtonEnabled()}
    />
}

export default HuntingGroupDetailView;